import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class FilterService {
    readonly #activatedRoute = inject(ActivatedRoute);
    readonly #router = inject(Router);

    clearDataFromUrl(): void {
        this.#activatedRoute.snapshot.queryParams = {};
        this.#router.navigate([])
    }

    getDataFromUrl(): { [key: string]: string } {
        return this.#activatedRoute.snapshot.queryParams;
    }

    removeDataFromUrl(param: string, filterFunction: Function): void {
        const actualParams = this.#activatedRoute.snapshot.queryParams;
        const newValue = filterFunction(this.#activatedRoute.snapshot.queryParams[param])
        const queryParams = {
            ...actualParams,
            [param]: newValue ? newValue : null
        };

        this.setQueryParams(queryParams);
    }

    addDataToUrl(params: Array<{ [key: string]: string }>): void {
        const queryParams: Record<string, string> = {};
        params.forEach((param: { [key: string]: string }) => {
            if (!!Object.values(param)[0])
                queryParams[Object.keys(param)[0]] = encodeURIComponent(Object.values(param)[0]);
        })
        
        this.setQueryParams(queryParams);
    }

    setQueryParams(queryParams: { [key: string]: string }): void {
        this.#activatedRoute.snapshot.queryParams = {};
        this.#router.navigate([], {
            relativeTo: this.#activatedRoute,
            queryParams,
            queryParamsHandling: 'merge'
        });
    }

}
